/*******************************************************************************

// Project: Justyna Niebieszczańska
// Author: Dominik Kucharski / mino.pl
// Date: 12.2017

********************************************************************************

  1. Polyfill for external SVG
  2. Scroll to top
  3. Off canvas menu
  4. Mobile Menu
  5. EU Cookie
  6. Polyfill to remove click delays on browsers with touch UIs
  7. Dropdown Menu
  8. Lightbox for images
  9. Responsive Videos
  10. Scoll Animations Init
  11. Object Fit Images
  12. Framework Scripts
  13. Contact Form 7 Fix

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Polyfill for external SVG
------------------------------------------------------------------------------*/

  svg4everybody();

/* 2. Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.scroll-to-top').addClass('show');
    } else {
      $('.scroll-to-top').removeClass('show');
    }
  });

  $('.scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* 3. Off canvas menu
------------------------------------------------------------------------------*/

  $('.toggle-nav').click(function() {
    // Calling a function in case you want to expand upon this.
    toggleNav();
  });

  function toggleNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      // Do things on Nav Close
      $('#site-wrapper').removeClass('show-nav');
    } else {
      // Do things on Nav Open
      $('#site-wrapper').addClass('show-nav');
    }
  }

  // Fuction for hiding mobile navigation
  function hideNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      $('#site-wrapper').removeClass('show-nav');
    }
  }

  // Hide navigation when user pressed Escape key on keyboard
  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      if ($('#site-wrapper').hasClass('show-nav')) {
        toggleNav();
      }
    }
  });

  // Hide mobile navigation when user increases browser size
  enquire.register("screen and (min-width: 768px)", {
    match : function() {
      hideNav();
    }
  });

/* 4. Mobile Menu
------------------------------------------------------------------------------*/

  $('ul.mob-menu li').has('ul').addClass('parentLi');
  $('ul.mob-menu li ul').addClass('sub-menu');

  $('ul.mob-menu .sub-menu').hide();

  $('ul.mob-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

/* 5. EU Cookie
------------------------------------------------------------------------------*/

  if(Cookies.get('eu-cookie-law') == 'accepted') {
    $('.cookie-bar').removeClass('cookie-bar--not-accepted');
  }
  else {
    $('.cookie-bar').addClass('cookie-bar--not-accepted');
  }

  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law', 'accepted', { expires: 180 });
    $('.cookie-bar').removeClass('cookie-bar--not-accepted');
  });

/* 6. Polyfill to remove click delays on browsers with touch UIs
------------------------------------------------------------------------------*/

  FastClick.attach(document.body);

/* 7. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.primary-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.primary-menu .menu-item-has-children a').length) {
      $('.primary-menu .menu-item-has-children').removeClass('opened');
    }
  });

/* 8. Lightbox for images
------------------------------------------------------------------------------*/

  $('a[href$=jpg], a[href$=jpeg], a[href$=jpe], a[href$=png], a[href$=gif]').magnificPopup({
    type: 'image',
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function() {
        // just a hack that adds mfp-anim class to markup
         this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
         this.st.mainClass = 'mfp-zoom-out';
      }
    },
    closeOnContentClick: true,
    midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });

/* 9. Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 10. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile'
  });

/* 11. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 12. Framework Scripts
/*******************************************************************************/

//= include framework-scripts.js

/* 13. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

  $('.the-rest-posts .entry-title').matchHeight();
  $('.the-rest-posts .entry-excerpt').matchHeight();
  $('.woocommerce-loop-product__title').matchHeight();

});
